import * as React from 'react';

import StorySnippetsSeparatedFromAnalytics, {
  Props as StorySnippetsSeparatedFromAnalyticsProps
} from './components/story-snippets-separated-from-analytics/StorySnippetsSeparatedFromAnalytics';
import StorySnippetsLinkedWithAnalytics, {
  OwnProps as StorySnippetsLinkedWithAnalyticsProps
} from './components/story-snippets-linked-with-analytics/StorySnippetsLinkedWithAnalytics';

import './redux/store';

interface StorySnippetsSeparatedFromAnalyticsType {
  type: 'story-snippets-separated-from-analytics',
  props: StorySnippetsSeparatedFromAnalyticsProps
}

interface StorySnippetsLinkedWithAnalyticsType {
  type: 'story-snippets-linked-with-analytics',
  props: StorySnippetsLinkedWithAnalyticsProps
}

type Props =
  | StorySnippetsSeparatedFromAnalyticsType
  | StorySnippetsLinkedWithAnalyticsType;

const StorySnippets = (props: Props) => (
  props.type === 'story-snippets-separated-from-analytics'
    ? <StorySnippetsSeparatedFromAnalytics {...props.props} />
    : <StorySnippetsLinkedWithAnalytics {...props.props} />
);

export default StorySnippets;
